import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TicketShareConfig from './ticketShareConfig';
import TicketShareRecord from './ticketShareRecord';
import TicketAcceptRecord from './ticketAcceptRecord';
export default {
  name: 'OilTicketShare',
  components: {
    TicketShareConfig: TicketShareConfig,
    TicketShareRecord: TicketShareRecord,
    TicketAcceptRecord: TicketAcceptRecord
  },
  data: function data() {
    return {
      activeName: 'TicketShareConfig'
    };
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      debugger;
      this.activeName = tab.name;
    }
  }
};